var _g, _path, _g2, _path2, _defs;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
var SvgAgentVerification = function SvgAgentVerification(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 96,
    height: 108,
    viewBox: "0 0 96 108",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_10345_110484)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M46.8216 60.4767C47.3961 60.1776 48.0797 60.1753 48.6562 60.4703L75.5213 74.2196C76.973 74.9626 76.973 77.0374 75.5213 77.7804L48.6562 91.5297C48.0797 91.8247 47.3961 91.8224 46.8216 91.5233L20.4081 77.774C18.9727 77.0269 18.9727 74.9731 20.4081 74.226L46.8216 60.4767Z",
    fill: "black",
    fillOpacity: 0.01
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_10345_110484",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 17,
    y: 12,
    width: 63,
    height: 72
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M46.1769 13.1547C47.4145 12.4402 48.9393 12.4402 50.1769 13.1547L77.3538 28.8453C78.5914 29.5598 79.3538 30.8803 79.3538 32.3094V63.6906C79.3538 65.1197 78.5914 66.4402 77.3538 67.1547L50.1769 82.8453C48.9393 83.5598 47.4145 83.5598 46.1769 82.8453L19.0008 67.1547C17.7633 66.4402 17.0009 65.1197 17.0008 63.6907L17.0001 32.3095C17 30.8804 17.7624 29.5598 19.0001 28.8453L46.1769 13.1547Z",
    fill: "#C4C4C4"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_10345_110484)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 36,
    height: 36,
    transform: "matrix(0.866025 0.5 -0.866025 0.5 48.2139 12)",
    fill: "url(#paint0_linear_10345_110484)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: -2.98023e-8,
    y: 0.5,
    width: 35,
    height: 35,
    transform: "matrix(0.866025 0.5 -0.866025 0.5 48.6469 12.25)",
    stroke: "white",
    strokeOpacity: 0.4
  }), /*#__PURE__*/React.createElement("rect", {
    width: 36,
    height: 36,
    transform: "matrix(0.866025 -0.5 2.20305e-08 1 48.2139 48)",
    fill: "url(#paint1_linear_10345_110484)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.433013,
    y: 0.25,
    width: 35,
    height: 35,
    transform: "matrix(0.866025 -0.5 2.20305e-08 1 48.2719 48.2165)",
    stroke: "white",
    strokeOpacity: 0.4
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_10345_110484)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M57.769 57.282L57.769 53.9062C57.769 53.6079 57.8717 53.2625 58.0544 52.946C58.2371 52.6295 58.4849 52.3679 58.7433 52.2188L61.6662 50.5312",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.3834 48.8445L72.3834 45.4688C72.3834 45.1704 72.2808 44.9435 72.0981 44.838C71.9154 44.7325 71.6676 44.7571 71.4092 44.9062L68.4863 46.5938",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.769 65.1562L57.769 68.5313C57.769 68.8296 57.8717 69.0565 58.0544 69.162C58.2371 69.2675 58.4849 69.2429 58.7433 69.0938L61.6662 67.4063",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.3834 56.7187L72.3834 60.0937C72.3834 60.3921 72.2808 60.7375 72.0981 61.054C71.9154 61.3705 71.6676 61.6321 71.4092 61.7812L68.4863 63.4687",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("ellipse", {
    rx: 2.57143,
    ry: 2.57143,
    transform: "matrix(0.866025 -0.5 2.20305e-08 1 65.0762 54.4285)",
    fill: "url(#paint2_linear_10345_110484)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.397 56.0156C62.397 56.8361 62.6793 57.4601 63.1817 57.7502C63.6842 58.0403 64.3657 57.9728 65.0762 57.5625C65.7868 57.1522 66.4683 56.4328 66.9708 55.5626C67.4732 54.6923 67.7555 53.7424 67.7555 52.9219C67.7555 52.1014 67.4732 51.4774 66.9708 51.1873C66.4683 50.8972 65.7868 50.9647 65.0762 51.375C64.3657 51.7853 63.6842 52.5047 63.1817 53.3749C62.6793 54.2452 62.397 55.1951 62.397 56.0156V56.0156Z",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.192 59.6861C68.8939 58.8722 68.3375 58.3388 67.6001 58.1599C66.8626 57.9809 65.9805 58.1654 65.076 58.6876C64.1715 59.2098 63.2894 60.0439 62.5519 61.0744C61.8144 62.1049 61.2581 63.2807 60.96 64.4389",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("rect", {
    width: 36,
    height: 36,
    transform: "matrix(0.866025 0.5 -2.20305e-08 1 17.0381 30)",
    fill: "url(#paint3_linear_10345_110484)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.433013,
    y: 0.75,
    width: 35,
    height: 35,
    transform: "matrix(0.866025 0.5 -2.20305e-08 1 17.0961 29.7835)",
    stroke: "white",
    strokeOpacity: 0.4
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M46.6769 14.0207C47.6051 13.4848 48.7487 13.4848 49.6769 14.0207L76.8538 29.7113C77.782 30.2472 78.3538 31.2376 78.3538 32.3094V63.6906C78.3538 64.7624 77.782 65.7528 76.8538 66.2887L49.6769 81.9793C48.7487 82.5152 47.6051 82.5152 46.6769 81.9792L19.5008 66.2887C18.5727 65.7528 18.0009 64.7624 18.0008 63.6907L18.0001 32.3094C18 31.2376 18.5718 30.2472 19.5001 29.7113L46.6769 14.0207Z",
    stroke: "white",
    strokeWidth: 2
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_10345_110484",
    x: 3.33154,
    y: 44.2507,
    width: 89.2786,
    height: 63.4985,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 8
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.54902 0 0 0 0 0.498039 0 0 0 0 0.972549 0 0 0 0.4 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_10345_110484"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    "in": "SourceGraphic",
    in2: "effect1_dropShadow_10345_110484",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_10345_110484",
    x1: -0.267884,
    y1: 0.267885,
    x2: 35.7321,
    y2: 0.267886,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A37EF4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#897EF7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_10345_110484",
    x1: -0.535769,
    y1: -0.267884,
    x2: 36.8338,
    y2: -0.136971,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8D7FF7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7769F7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_10345_110484",
    x1: 5.14286,
    y1: 5.14143,
    x2: -0.403299,
    y2: 0.479826,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_10345_110484",
    x1: 17.2767,
    y1: -10.1384,
    x2: 43.4682,
    y2: -1.59252,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A07FF5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7564F7"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_10345_110484"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    fill: "white",
    transform: "matrix(0.866025 -0.5 2.20305e-08 1 57.2817 52.5)"
  })))));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgAgentVerification);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "agent_verification.e65134e8aeea169b173c5765b0edde7f.svg";